"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.meApiClient = meApiClient;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function meApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function getCurrentPermissions() {
        try {
            const response = await client.get('/v1/me/permissions');
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        getCurrentPermissions
    };
}
